import { Component } from '@angular/core'
import { MbCheckoutRegions } from '../../../../models'
import { MbOrderDetailsBaseComponent } from '../mb-order-details-base.component'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-details-au',
  templateUrl: './mb-order-details-au.component.html',
  styleUrls: ['../mb-order-details-base.component.scss']
})
export class MbOrderDetailsAuComponent extends MbOrderDetailsBaseComponent {

  checkoutRegion = MbCheckoutRegions.AU

  constructor (protected orderService: OrderHistoryService) {
    super(orderService)
  }
}
